import axios from 'axios';
const client = axios.create({ withCredentials: true });

const SETTINGS = {
    apiKey: '',
    apiUrl: import.meta.env.VITE_DRUPAL_URL,
    siteUrl: ''
};

const DRUPAL_API_ROUTE = {
    CRSF_TOKEN: {
        method: 'GET',
        path: '/en/session/token?_format=json'
    },
    LOGOUT_TOKEN: {
        method: 'GET',
        path: '/en/session/logout/token?_format=json'
    },
    LOGOUT: {
        method: 'POST',
        path: '/en/user/logout?_format=json&token=:logout_token'
    },
    USER_DATA: {
        method: 'GET',
        path: '/en/user/:uid?_format=json'
    },
    USER: {
        method: 'GET',
        path: '/en/api/user'
    },
    USER_LANGUAGE: {
        method: 'GET',
        path: '/en/api/user/language'
    },
    USER_UPDATE: {
        method: 'PATCH',
        path: '/en/user/:uid?_format=json'
    },
    USER_CANCEL: {
        method: 'DELETE',
        path: '/en/api/users/cancel'
    },
    USER_JOURNAL: {
        method: 'GET',
        path: '/en/api/journal/login?offset=:offset&limit=:limit'
    },
    USER_APIKEY: {
        method: 'GET',
        path: '/en/api/account/apikeys'
    },
    USER_APIKEY_GENERATE: {
        method: 'POST',
        path: '/en/api/account/apikey/generate'
    },
    USER_APIKEY_DELETE: {
        method: 'DELETE',
        path: '/en/api/account/apikey/delete/:uuid'
    },
    STRIPE_USER: {
        method: 'GET',
        path: '/en/api/stripe/user'
    },
    STRIPE_INVOICES: {
        method: 'GET',
        path: '/en/api/stripe/invoices'
    },
    SHORTEN: {
        method: 'POST',
        path: '/en/api/links/shorten'
    },
    SHORTLINKS: {
        method: 'GET',
        path: '/en/api/links/extend?offset=:offset&uid=:uid&tags=:tags&domain=:domain&note=:note&path=:path&expiration=:expiration&reset=:reset'
    },
    SHORTLINK: {
        method: 'GET',
        path: '/en/api/links/extend/:uuid'
    },
    SHORTLINK_UPDATE: {
        method: 'PATCH',
        path: '/en/api/links/update/:uuid'
    },
    SHORTLINK_DELETE: {
        method: 'DELETE',
        path: '/en/api/links/delete/:uuid'
    },
    SHORTLINK_QRCODE_CREATE: {
        method: 'POST',
        path: '/en/api/qrcodes/create'
    },
    SHORTLINK_QRCODE_UUID: {
        method: 'POST',
        path: '/en/api/qr/:uuid/create'
    },
    SHORTLINK_QRCODE: {
        method: 'GET',
        path: '/en/api/links/qrcode/:uuid'
    },
    SHORTLINK_CUSTOM_PATH_AI: {
        method: 'POST',
        path: '/en/api/links/path/ai'
    },
    SHORTLINKS_EXPORT: {
        method: 'POST',
        path: '/en/api/links/export'
    },
    ANALYTICS: {
        method: 'GET',
        path: '/en/api/analytics?id_site=:id_site&start_date=:start_date&end_date=:end_date&item_id=:item_id&domain=:domain&type=:type'
    },
    ANALYTICS_IPS: {
        method: 'GET',
        path: '/en/api/analytics/:id'
    },
    ANALYTICS_IPS_UPDATE: {
        method: 'PATCH',
        path: '/en/api/analytics/update/:id'
    },
    ANALYTICS_EXPORTS: {
        method: 'POST',
        path: '/en/api/analytics/exports?email=:email'
    },
    TAGS: {
        method: 'GET',
        path: '/en/api/tags'
    },
    TAG_CREATE: {
        method: 'POST',
        path: '/en/api/tags/create'
    },
    TAG_UPDATE: {
        method: 'PATCH',
        path: '/en/api/tags/update/:uuid'
    },
    TAG_DELETE: {
        method: 'DELETE',
        path: '/en/api/tags/delete/:uuid'
    },
    PIXELS: {
        method: 'GET',
        path: '/en/api/pixels'
    },
    PIXEL_ADD: {
        method: 'POST',
        path: '/en/api/pixels/add'
    },
    PIXEL_UPDATE: {
        method: 'PATCH',
        path: '/en/api/pixels/update/:uuid'
    },
    PIXEL_DELETE: {
        method: 'DELETE',
        path: '/en/api/pixels/delete/:uuid'
    },
    QRCODES_TEMPLATES: {
        method: 'GET',
        path: '/en/api/qrcodes/templates'
    },
    QRCODES_TEMPLATE: {
        method: 'GET',
        path: '/en/api/qrcodes/templates/:uuid'
    },
    QRCODE_TEMPLATE_ADD: {
        method: 'POST',
        path: '/en/api/qrcodes/templates/add'
    },
    QRCODE_TEMPLATE_EDIT: {
        method: 'POST',
        path: '/en/api/qrcodes/templates/update/:uuid'
    },
    QRCODE_TEMPLATE_DELETE: {
        method: 'DELETE',
        path: '/en/api/qrcodes/templates/delete/:uuid'
    },
    IMAGE_UPLOAD: SETTINGS.apiUrl + '/en/api/image/upload',
    WEBFORMS: {
        method: 'GET',
        path: '/en/api/webforms'
    },
    WEBFORM: {
        method: 'GET',
        path: '/en/api/webforms/:uuid'
    },
    WEBFORM_ALIAS: {
        method: 'POST',
        path: '/en/api/webforms/alias'
    },
    WEBFORM_CREATE: {
        method: 'POST',
        path: '/en/api/webforms/create'
    },
    WEBFORM_UPDATE: {
        method: 'PATCH',
        path: '/en/api/webforms/update/:uuid'
    },
    WEBFORM_DELETE: {
        method: 'DELETE',
        path: '/en/api/webforms/delete/:uuid'
    },
    WEBFORM_BANNER_UPLOAD: SETTINGS.apiUrl + '/en/api/webforms/upload/banner',
    WEBFORM_WEBFORM: {
        method: 'GET',
        path: '/en/api/webforms/:uuid/:id?page=:page'
    },
    WEBFORM_WEBFORM_SETTINGS: {
        method: 'GET',
        path: '/en/api/webforms/:uuid/:id/settings'
    },
    WEBFORM_WEBFORM_UPDATE: {
        method: 'PATCH',
        path: '/en/api/webforms/:uuid/:id'
    },
    WEBFORM_WEBFORM_ELEMENTS_CREATE: {
        method: 'POST',
        path: '/en/api/webforms/:uuid/:id/elements'
    },
    WEBFORM_WEBFORM_ELEMENTS_ORDER: {
        method: 'PATCH',
        path: '/en/api/webforms/:uuid/:id/order?page=:page'
    },
    WEBFORM_WEBFORM_ELEMENTS_UPDATE: {
        method: 'PATCH',
        path: '/en/api/webforms/:uuid/:id/elements/:element'
    },
    WEBFORM_WEBFORM_ELEMENTS_DELETE: {
        method: 'DELETE',
        path: '/en/api/webforms/:uuid/:id/elements/:element?page=:page'
    },
    WEBFORM_SUBMISSIONS: {
        method: 'GET',
        path: '/en/api/webforms/:uuid/submissions/:id?offset=:offset'
    },
    WEBFORM_SUBMISSIONS_SUMMARY: {
        method: 'GET',
        path: '/en/api/webforms/submissions/:id/summary?page=:page'
    },
    WEBFORM_SUBMISSIONS_DOWNLOAD: {
        method: 'GET',
        path: '/en/api/webforms/:uuid/submissions/:id/download?ids=:ids'
    },
    WEBFORM_SUBMISSIONS_UPDATE: {
        method: 'PATCH',
        path: '/en/api/webforms/:uuid/submissions/:id/:sid'
    },
    WEBFORM_SUBMISSIONS_DELETE: {
        method: 'DELETE',
        path: '/en/api/webforms/:uuid/submissions/:id'
    },
    DOMAINS: {
        method: 'GET',
        path: '/en/api/domains'
    },
    ACTIVE_DOMAINS: {
        method: 'GET',
        path: '/en/api/domains?status=:status'
    },
    DOMAIN: {
        method: 'GET',
        path: '/en/api/domains/:uuid'
    },
    DOMAIN_ADD: {
        method: 'POST',
        path: '/en/api/domains/add'
    },
    DOMAIN_UPDATE: {
        method: 'PATCH',
        path: '/en/api/domains/update/:uuid'
    },
    DOMAIN_DELETE: {
        method: 'DELETE',
        path: '/en/api/domains/delete/:uuid'
    },
    DOMAIN_VERIFY: {
        method: 'PATCH',
        path: '/en/api/domains/:uuid/recheck'
    },
    DOMAIN_SEARCH: {
        method: 'GET',
        path: '/en/api/domains/search?domain=:domain'
    },
    DOMAIN_SEARCH_PRICES: {
        method: 'GET',
        path: '/en/api/domains/prices?domain=:domain'
    },
    MISCELLANEOUS_COUNTRIES: {
        method: 'GET',
        path: '/:language/api/miscellaneous/countries'
    },
    MISCELLANEOUS_LANGUAGES: {
        method: 'GET',
        path: '/en/api/miscellaneous/languages'
    },
    MISCELLANEOUS_TIMEZONES: {
        method: 'GET',
        path: '/en/api/miscellaneous/timezones'
    },
    MISCELLANEOUS_VATVALIDATION: {
        method: 'POST',
        path: '/en/api/miscellaneous/vatvalidation'
    },
    BULKS: {
        method: 'GET',
        path: '/en/api/bulk'
    },
    BULK_TEST: {
        method: 'POST',
        path: '/en/api/bulk/test'
    },
    BULK_UPLOAD: SETTINGS.apiUrl + '/en/api/bulk/upload',
    BULK_DOWNLOAD: {
        method: 'GET',
        path: '/en/api/bulk/download/:uuid?qrcodes=:qrcodes'
    },
    BULK_CREATE: {
        method: 'POST',
        path: '/en/api/bulk/create'
    },
    BULK_TEMPLATE: {
        method: 'POST',
        path: '/en/api/bulk/template'
    },
    WORKSPACES: {
        method: 'GET',
        path: '/en/api/workspaces/extend'
    },
    WORKSPACE: {
        method: 'GET',
        path: '/en/api/workspaces/:uuid'
    },
    WORKSPACE_PLAN: {
        method: 'GET',
        path: '/en/api/workspaces/plan'
    },
    WORKSPACE_CREATE: {
        method: 'POST',
        path: '/en/api/workspaces/create'
    },
    WORKSPACE_UPDATE: {
        method: 'PATCH',
        path: '/en/api/workspaces/update/:uuid'
    },
    WORKSPACE_DELETE: {
        method: 'DELETE',
        path: '/en/api/workspaces/:uuid/delete'
    },
    WORKSPACE_USERS: {
        method: 'GET',
        path: '/en/api/workspaces/:uuid?expanded=:expanded'
    },
    WORKSPACES_USERS: {
        method: 'GET',
        path: '/en/api/workspaces/members'
    },
    WORKSPACES_INVITES: {
        method: 'GET',
        path: '/en/api/workspaces/invites'
    },
    WORKSPACE_INVITES: {
        method: 'GET',
        path: '/en/api/workspaces/:uuid/invites'
    },
    WORKSPACE_INVITE_UPDATE: {
        method: 'PATCH',
        path: '/en/api/workspaces/:workspace/invites/:uuid/update'
    },
    WORKSPACE_MEMBER_INVITE: {
        method: 'POST',
        path: '/en/api/workspaces/:workspace/invites/create'
    },
    WORKSPACE_MEMBER_UPDATE: {
        method: 'PATCH',
        path: '/en/api/workspaces/:workspace/members/:uuid'
    },
    WORKSPACE_MEMBER_DELETE: {
        method: 'DELETE',
        path: '/en/api/workspaces/:workspace/members/:uuid'
    },
    WORKSPACE_MEMBER_DELETE_ALL: {
        method: 'DELETE',
        path: '/en/api/workspaces/all/members/:uuid'
    },
    WORKSPACES_DOMAINS_LIST: {
        method: 'GET',
        path: '/en/api/workspaces/:workspace/domains?type=:type'
    },
    WORKSPACE_DOMAIN_ADD: {
        method: 'POST',
        path: '/en/api/workspaces/:workspace/domains/add'
    },
    WORKSPACE_JOURNAL: {
        method: 'GET',
        path: '/en/api/journal/:workspace?offset=:offset&limit=:limit'
    },
    WORKSPACE_ROLES: {
        method: 'GET',
        path: '/en/api/workspaces/roles'
    },
    WORKSPACE_CURRENT: {
        method: 'POST',
        path: '/en/api/workspaces/current'
    },
    WORKSPACE_DEFAULT: {
        method: 'GET',
        path: '/en/api/workspaces/default'
    },
    STRIPE_CUSTOMER: {
        method: 'GET',
        path: '/en/api/stripe/customer'
    },
    STRIPE_CUSTOMER_UPSERT: {
        method: 'POST',
        path: '/en/api/stripe/customer/upsert'
    },
    STRIPE_CUSTOMER_CARD_DELETE: {
        method: 'DELETE',
        path: '/en/api/stripe/customer/card/delete'
    },
    STRIPE_CANCEL: {
        method: 'DELETE',
        path: '/en/api/stripe/cancel'
    },
    PAGES: {
        method: 'GET',
        path: '/en/api/links/extend?type=2'
    },
    REPORTS_SCHEDULED: {
        method: 'GET',
        path: '/en/api/scheduled'
    },
    REPORT_SCHEDULED: {
        method: 'GET',
        path: '/en/api/scheduled/:uuid'
    },
    REPORT_SCHEDULED_CREATE: {
        method: 'POST',
        path: '/en/api/scheduled'
    },
    REPORT_SCHEDULED_UPDATE: {
        method: 'PATCH',
        path: '/en/api/scheduled/:uuid'
    },
    SCHEDULED_DELETE: {
        method: 'DELETE',
        path: '/en/api/scheduled/:uuid'
    },
    JOURNAL_USAGE: {
        method: 'GET',
        path: '/en/api/journal/usage?workspaces=:workspace'
    },
    JOURNAL_CONNECTIONS: {
        method: 'GET',
        path: '/en/api/journal/workspaces/connections?workspaces=:workspace'
    },
    JOURNAL_WORKSPACES: {
        method: 'GET',
        path: '/en/api/journal/workspaces/totalinks?workspaces=:workspace'
    },
    JOURNAL_WORKSPACES_ACCESS: {
        method: 'GET',
        path: '/en/api/journal/workspaces/access'
    }
};

const callAPI = async function (route, params = {}, data = {}) {
    const { method, path } = route;
    const url = SETTINGS.apiUrl + bindQueryParams(path, params);
    const headers = {};

    headers['content-type'] = 'application/json';
    headers['Accept'] = '*/*';

    const writeMethods = ['POST', 'PATCH', 'DELETE'];
    if (writeMethods.includes(method) || route == 'LOGOUT') {
        var csrfToken = await client({
            method: DRUPAL_API_ROUTE.CRSF_TOKEN.method,
            url: SETTINGS.apiUrl + DRUPAL_API_ROUTE.CRSF_TOKEN.path
        });
        headers['X-CSRF-Token'] = csrfToken.data;
    }

    try {
        const res = await client({
            method,
            url,
            headers,
            data
        });
        return res;
    } catch (err) {
        if (err.response && err.message) {
            return { code: err.response.status, status: err.response.status, message: err.message };
        } else {
            //return { code: err.response.status, status: err.response.status, message: err.response.data.message };
        }
    }
};

function bindQueryParams(url, params) {
    for (const key of Object.keys(params)) {
        url = url.replace(`:${key}`, encodeURIComponent(params[key]));
    }

    return url;
}

export { callAPI, DRUPAL_API_ROUTE, SETTINGS };
